import React from 'react'
import { CrossClientQueryResultSource } from '../../../../models/CrossClient'
import { formatRelativeDateTime } from '../../../../common/dateUtils'
import { CrossClientResultDetailSourceIcon } from './CrossClientResultSourceIcon'
import { getCrossClientResultDetailSourceLabel } from './utils'

export interface CrossClientResultSourceProps {
  resultSource: CrossClientQueryResultSource
}

export const CrossClientResultSource: React.FC<CrossClientResultSourceProps> = ({ resultSource }) => {
  const label = getCrossClientResultDetailSourceLabel(resultSource.source)
  const retrievedAt = resultSource.retrievedAt ? formatRelativeDateTime(new Date(resultSource.retrievedAt)) : null

  return (
    <span className='d-flex align-items-center gap-1 paragraph-small zocks-text-gray-700 ps-4'>
      <CrossClientResultDetailSourceIcon source={resultSource.source} />
      <span className='ms-1'>{retrievedAt ? `${label}, as of ${retrievedAt}` : label}</span>
    </span>
  )
}
